// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ContextMaker$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/ContextMaker.res.mjs";
import * as FlagsContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/FlagsContext.res.mjs";

var allColors = [
  "slate",
  "gray",
  "zinc",
  "neutral",
  "stone",
  "red",
  "orange",
  "amber",
  "yellow",
  "lime",
  "green",
  "emerald",
  "teal",
  "cyan",
  "sky",
  "blue",
  "indigo",
  "violet",
  "purple",
  "fuchsia",
  "pink",
  "rose"
];

var Api = {
  name: "V3StylePreferences"
};

var include = ContextMaker$LiteracyplanetClientFlags.Make(Api);

var Provider = include.Provider;

var use = include.use;

function usePrefs(param) {
  return use().prefs;
}

function useSetter(param) {
  return use().setPrefs;
}

function V3StylePreferences(props) {
  var prefs = props.prefs;
  FlagsContext$LiteracyplanetClientFlags.use();
  var match = React.useState(function () {
        return prefs;
      });
  var match$1 = React.useState(function () {
        return false;
      });
  var setShowPrefs = match$1[1];
  var toggleShowPrefs = function (param) {
    setShowPrefs(function (t) {
          return !t;
        });
  };
  return React.createElement(Provider.make, {
              value: {
                prefs: match[0],
                setPrefs: match[1],
                toggleShowPrefs: toggleShowPrefs,
                show: match$1[0]
              },
              children: props.children
            });
}

var initialContext = include.initialContext;

var context = include.context;

var P = include.P;

var ContextMakerProviderNotFound = include.ContextMakerProviderNotFound;

var make = V3StylePreferences;

export {
  allColors ,
  Api ,
  initialContext ,
  context ,
  P ,
  Provider ,
  ContextMakerProviderNotFound ,
  use ,
  usePrefs ,
  useSetter ,
  make ,
}
/* include Not a pure module */
